function scrollToReviews(event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    
    const reviewSection = document.querySelector('#junip-review-section-custom');
    
    if (reviewSection) {
        reviewSection.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
        });
        
        if (history.pushState) {
            const newUrl = window.location.pathname + window.location.search + '#junip-review-section-custom';
            history.pushState(null, '', newUrl);
        } else {
            window.location.hash = 'junip-review-section-custom';
        }
    } else {
        console.warn('Review section #junip-review-section-custom not found');
    }
}

document.addEventListener('DOMContentLoaded', function() {
    if (window.location.hash === '#junip-review-section-custom') {
        setTimeout(function() {
            scrollToReviews();
        }, 100);
    }
});
